import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.CustomerSettingsPage.title',
    defaultMessage: 'Account Details',
  },
  description: {
    id: 'containers.CustomerSettingsPage.description',
    defaultMessage: 'These are the details we have on record, on your account.',
  },
  name: {
    id: 'containers.CustomerSettingsPage.name',
    defaultMessage: 'Name',
  },
  city: {
    id: 'containers.CustomerSettingsPage.city',
    defaultMessage: 'City',
  },
  zip: {
    id: 'containers.CustomerSettingsPage.zip',
    defaultMessage: 'Postal Code',
  },
  address: {
    id: 'containers.CustomerSettingsPage.address',
    defaultMessage: 'Address',
  },
  country: {
    id: 'containers.CustomerSettingsPage.country',
    defaultMessage: 'Country',
  },
  vat: {
    id: 'containers.CustomerSettingsPage.vat',
    defaultMessage: 'VAT',
  },
  ean: {
    id: 'containers.CustomerSettingsPage.ean',
    defaultMessage: 'EAN',
  },
  phone: {
    id: 'containers.CustomerSettingsPage.phone',
    defaultMessage: 'Phone',
  },
  email: {
    id: 'containers.CustomerSettingsPage.email',
    defaultMessage: 'E-mail',
  },
})
